<script setup lang="ts">import { computed as _computed } from 'vue';

import {UserStatusType} from '@toolify/server/src/models/mongoose/UserModel/enum/UserStatusType'
import IconComponent from '@toolify/client/src/modules/ui/components/IconComponent.vue'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {IconWeightType} from '@toolify/client/src/modules/ui/enum/IconWeightType'



interface Props {
  statusType: UserStatusType
}

const props = defineProps<Props>()

const statusBackgroundColorByTypeMap = _computed(() => {
  return new Map([
    // [UserStatusType.Online, '#34b255'],
    [UserStatusType.Online, 'transparent'],
    // [UserStatusType.Away, props.statusBorderColor],
    [UserStatusType.Away, 'rgb(255, 153, 51)'],
    [UserStatusType.Busy, 'hsl(4deg, 90%, 61%)'],
    [UserStatusType.Offline, 'transparent'],
  ])
})
</script>

<template>
  <div
    class="entity-status-circle"
    :class="{[`status-type-${statusType}`]: !!statusType}"
  >
    <!--    <i class="fas fa-globe icon icon-online" :style="iconStyle" v-if="statusType === UserStatusType.Online"/>-->
    <IconComponent
      :name="IconNameType.Ghost"
      :weightType="IconWeightType.Solid"
      class="icon icon-offline"
      v-if="statusType === UserStatusType.Offline"
    />
    <IconComponent
      :name="IconNameType.Snooze"
      :weightType="IconWeightType.Solid"
      class="icon icon-away"
      v-if="statusType === UserStatusType.Away"
    />
    <IconComponent
      :name="IconNameType.Hyphen"
      :weightType="IconWeightType.Solid"
      class="icon icon-busy"
      v-if="statusType === UserStatusType.Busy"
    />
  </div>
</template>

<style scoped lang="scss">
@use '@toolify/client/src/styles/variables' as variables;

  .entity-status-circle {
    border-radius: 50%;
    height: 100%;
    aspect-ratio: 1/1;
    display: flex;
    justify-content: center;
    align-items: center;

    &.status-type {
      &-away {
        background: rgb(255, 153, 51);
      }

      &-online {
        background:  #34b255;
      }

      &-offline {
        background: map-get(variables.$colors, overlay-33);
      }

      &-busy {
        background: hsl(4deg, 90%, 61%);
      }
    }
  }

  .icon {
    font-size: map-get(variables.$textSizes, text-3xs);
  }
</style>
